import React, { useContext, useEffect, useState, useRef } from 'react'
import { ThemeContext } from '../context/themeContext';
import { DeviceWidthContext } from '../context/deviceWidthContext';
import { IoIosClose } from "react-icons/io";
import { LiaGripLinesSolid } from "react-icons/lia";

export default function NavBar({scrollYPosition, lang, setLang, langOptions, hideNav}) {

  const {deviceWidth, toggleMobileNav, mobileNavActive} = useContext(DeviceWidthContext)

  const {toggleTheme, darkTheme} = useContext(ThemeContext)
  const [animate, setAnimate] = useState(false)
  const [activeLink, setActiveLink] = useState()

  let storage = window.localStorage


  const handleLang = () => {  
      if(lang === "en") {
        setLang("fr")
      } else {
        setLang("en")
      }

      if(deviceWidth < 800) {
        toggleMobileNav(!mobileNavActive)
      }
  }

  useEffect(() => {

    if(storage.getItem("lang")) {
      setLang(storage.getItem("lang"))
    }
  }, [])

  useEffect(() => {
    storage.setItem("lang", lang)
  }, [lang])

  const switchTheme = () => {
    toggleTheme()
    setAnimate(true)
    let timer = setTimeout(() => {
      setAnimate(false)
    }, 300)

    return () => {
      clearTimeout(timer)
    }
  }

  

  return (

    <>

    {deviceWidth > 800 ?
      <nav className={`${scrollYPosition > 25 ? "blurry" : ""} ${!hideNav  ? "hide" : ""}`}>
        <div className="brand">
          {scrollYPosition > 25 ? <span className='identity'>Nina Socrate</span>  : <div className='sign identity'><img src="Assets/sign.png" alt="" /></div>}
            <span>Web developper</span>
        </div>
        <ul>
            {langOptions.navItems[lang].map((item) =>
                (<li className={`hover-target ${activeLink === item && "active"}`} onClick={() => setActiveLink(item)}><a href={`#${item.replace(" ", "-")}-section`}>{item}</a></li>)
              )
            }
            <li className="langSwitch hover-target" onClick={() => handleLang()}>
                <p>{lang}</p>
            </li>
            <li className={`themeSwitch ${animate ? "animate" : ""} hover-target`} onClick={() => switchTheme()}>
              <div className="switch hover-target"></div>
            </li>
        </ul>
      </nav>

      :

      <nav className={`${scrollYPosition > 25 ? "blurry" : ""}`}>
        <div className="brand">
          {scrollYPosition > 25 ? <span className='identity'>Nina Socrate</span>  : <div className='sign identity'><img src="Assets/sign.png" alt="" /></div>}
            <span>Web developper</span>
        </div>
        <div className="toggle" onClick={() => toggleMobileNav(!mobileNavActive)}>
          {!mobileNavActive ? <LiaGripLinesSolid /> : <IoIosClose />}
        </div>

        <ul className={`mobileNav ${mobileNavActive ? "active" : ""}`} > 
            {langOptions.navItems[lang].map((item) =>
                (<li className={`hover-target ${activeLink === item && "active"}`} onClick={() => setActiveLink(item)}><a href={`#${item.replace(" ", "-")}-section`} onClick={() => toggleMobileNav(!mobileNavActive)}>{item}</a></li>)
              )
            }
            <li className="langSwitch hover-target" onClick={() => handleLang()}>
                <p className='hover-target'>{lang}</p>
            </li>
            <li className={`themeSwitch ${animate ? "animate" : ""} hover-target`} onClick={() => switchTheme()}>
              <div className="switch hover-target" onClick={() => toggleMobileNav(!mobileNavActive)}></div>
            </li>
        </ul>
      </nav>
      
      }
    </>

  )
}
